(function () {
  var instances = new WeakMap();
  var depsPromises = {};

  function getEffectType(el) {
    return el.getAttribute('data-vanta-effect') === 'halo' ? 'halo' : 'waves';
  }

  function getSources(el) {
    var config = window.HeroBannerVantaConfig || {};
    var effect = getEffectType(el);
    var vantaSrc =
      el.getAttribute('data-vanta-src') ||
      (effect === 'halo' ? config.haloSrc : config.wavesSrc);

    return {
      three: config.threeSrc || el.getAttribute('data-three-src'),
      vanta: vantaSrc,
      effect: effect,
    };
  }

  function hexToInt(hex, fallback) {
    if (!hex) return fallback;
    var h = String(hex).replace('#', '').trim();
    if (h.length === 3) {
      h = h
        .split('')
        .map(function (c) {
          return c + c;
        })
        .join('');
    }
    var n = parseInt(h, 16);
    return Number.isNaN(n) ? fallback : n;
  }

  function applyHaloBrightness(hex, brightness) {
    var n = hexToInt(hex, 0x7261f4);
    var factor = Math.max(0, Math.min(1, parseFloat(brightness)));
    if (Number.isNaN(factor)) factor = 0.7;

    var r = Math.round(((n >> 16) & 255) * factor);
    var g = Math.round(((n >> 8) & 255) * factor);
    var b = Math.round((n & 255) * factor);
    return (r << 16) | (g << 8) | b;
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (!src) {
        reject(new Error('Missing script URL'));
        return;
      }

      var existing = document.querySelector('script[data-hero-vanta-src="' + src + '"]');
      if (existing) {
        if (existing.getAttribute('data-loaded') === 'true') {
          resolve();
          return;
        }
        existing.addEventListener('load', function () {
          resolve();
        });
        existing.addEventListener('error', function () {
          reject(new Error('Failed to load ' + src));
        });
        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.async = false;
      script.setAttribute('data-hero-vanta-src', src);
      script.onload = function () {
        script.setAttribute('data-loaded', 'true');
        resolve();
      };
      script.onerror = function () {
        reject(new Error('Failed to load ' + src));
      };
      document.head.appendChild(script);
    });
  }

  function vantaReady(effect) {
    if (!window.THREE || !window.VANTA) return false;
    return effect === 'halo' ? !!window.VANTA.HALO : !!window.VANTA.WAVES;
  }

  function loadVantaDeps(sources) {
    if (vantaReady(sources.effect)) {
      return Promise.resolve();
    }

    if (!depsPromises[sources.vanta]) {
      depsPromises[sources.vanta] = loadScript(sources.three)
        .then(function () {
          return loadScript(sources.vanta);
        })
        .then(function () {
          if (!vantaReady(sources.effect)) {
            throw new Error('VANTA.' + sources.effect.toUpperCase() + ' unavailable after scripts loaded');
          }
        })
        .catch(function (err) {
          delete depsPromises[sources.vanta];
          throw err;
        });
    }

    return depsPromises[sources.vanta];
  }

  function destroyVanta(el) {
    var inst = instances.get(el);
    if (inst && typeof inst.destroy === 'function') {
      inst.destroy();
    }
    instances.delete(el);
    el.removeAttribute('data-vanta-ready');
  }

  function whenSized(el, cb, attempt) {
    attempt = attempt || 0;
    if (el.offsetWidth >= 100 && el.offsetHeight >= 100) {
      cb();
      return;
    }
    if (attempt > 40) {
      cb();
      return;
    }
    requestAnimationFrame(function () {
      whenSized(el, cb, attempt + 1);
    });
  }

  function createEffect(el, effect) {
    var shared = {
      el: el,
      mouseControls: true,
      touchControls: true,
      gyroControls: false,
      minHeight: 200,
      minWidth: 200,
      backgroundColor: hexToInt(
        el.dataset.vantaBg,
        getEffectType(el) === 'waves' ? 0x000000 : 0x0a0d12
      ),
    };

    if (effect === 'halo') {
      return window.VANTA.HALO(
        Object.assign(shared, {
          baseColor: applyHaloBrightness(
            el.dataset.vantaColor,
            el.dataset.vantaHaloBrightness
          ),
          size: parseFloat(el.dataset.vantaSize) || 1,
          amplitudeFactor: parseFloat(el.dataset.vantaAmplitude) || 0.9,
          xOffset: parseFloat(el.dataset.vantaXoffset) || 0,
          yOffset: parseFloat(el.dataset.vantaYoffset) || 0,
        })
      );
    }

    return window.VANTA.WAVES(
      Object.assign(shared, {
        scale: 1,
        scaleMobile: 1,
        color: hexToInt(el.dataset.vantaColor, 0x7261f4),
        shininess: parseFloat(el.dataset.vantaShininess) || 35,
        waveHeight: parseFloat(el.dataset.vantaWaveHeight) || 18,
        waveSpeed: parseFloat(el.dataset.vantaWaveSpeed) || 0.7,
        zoom: parseFloat(el.dataset.vantaZoom) || 0.9,
      })
    );
  }

  function initVantaEl(el) {
    if (!el || el.getAttribute('data-vanta-ready') === 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var sources = getSources(el);
    if (!sources.three || !sources.vanta) return;

    loadVantaDeps(sources)
      .then(function () {
        whenSized(el, function () {
          if (!vantaReady(sources.effect)) return;

          destroyVanta(el);

          var instance = createEffect(el, sources.effect);
          instances.set(el, instance);
          el.setAttribute('data-vanta-ready', 'true');
        });
      })
      .catch(function () {
        el.setAttribute('data-vanta-error', 'true');
      });
  }

  function initAll() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.hero-banner__vanta[data-hero-vanta]').forEach(initVantaEl);
  }

  function boot() {
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('.hero-banner__vanta[data-hero-vanta]').forEach(initVantaEl);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('.hero-banner__vanta[data-hero-vanta]').forEach(destroyVanta);
  });

  window.addEventListener(
    'resize',
    function () {
      document.querySelectorAll('.hero-banner__vanta[data-hero-vanta]').forEach(function (el) {
        var inst = instances.get(el);
        if (inst && typeof inst.resize === 'function') {
          inst.resize();
        }
      });
    },
    { passive: true }
  );
})();
